import React from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
import { BuildCardCarousel } from './BuildCardCarousel';
export function CardPreview() {
  return <div className="mt-6 sm:mt-8" data-id="element-53" data-mp="2iskmjoz1ji12">
      <div className="mb-8 flex flex-col items-center text-center" data-id="element-54" data-mp="2irjcnntrh1kx">
        <span className="text-xs font-bold uppercase tracking-widest text-primary-strong" data-id="element-55" data-mp="2du9hrsnlrxpp">
          ZAJRZYJ DO ŚRODKA KARTY
        </span>
        <h3 className="mt-2 font-display text-2xl font-bold leading-tight text-foreground sm:text-3xl" data-id="element-56" data-mp="1q1j85q369qil">
          Jedna karta. <span className="text-primary" data-id="element-57" data-mp="1ztgjqxy3ekhu">Jedna konkretna przygoda.</span>
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-foreground/75 sm:text-base" data-id="element-58" data-mp="1zv9rkgkfzarf">
          Każda karta mówi, co przygotować, ile to potrwa, jak bardzo jest trudne, czy potrzebna
          będzie pomoc dorosłego, jak to zbudować, dlaczego działa i co sprawdzić potem.
        </p>

        <BuildCardCarousel data-id="element-59" data-mp="12dsy1n50mux1" />
      </div>

      <CTAButton label="CHCĘ PRACOWNIĘ MAŁEGO WYNALAZCY" href={CHECKOUT_URL} external data-id="element-60" data-mp="q2die8ajanh" />
      <TodayOfferCard data-id="element-61" data-mp="4re2chjcbrum" />
      <div className="mt-4 rounded-xl border border-primary/15 bg-secondary px-4 py-3 text-center" data-id="element-62" data-mp="4qm7j8xkhy5e">
        <p className="text-sm font-bold text-primary-strong" data-id="element-63" data-mp="9hui48amvpk5">🔒 Bezpieczna płatność</p>
        <p className="mt-1 text-xs leading-relaxed text-foreground/70 sm:text-sm" data-id="element-64" data-mp="ehqm47jbzgzp">
          BLIK, Przelewy24 i karty płatnicze. Twoja płatność 69 zł jest szyfrowana i przetwarzana
          bezpiecznie.
        </p>
      </div>
    </div>;
}